module.exports = __webpack_public_path__ + "img/delBlue.55b6f861.png";